import QuillRenderer from './QuillRenderer'

export default QuillRenderer
